var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPragAutomatWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fb5f5f93-0c6a-4ef4-9271-848fc7c0f7a0",
    "data-name": "toc_automat",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.66 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a7f81b46-c374-46eb-9dec-8d5ba40673a7,.b74477aa-6c34-4980-963c-030318d70f5f{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.b74477aa-6c34-4980-963c-030318d70f5f{stroke-width:10px;}.a7f81b46-c374-46eb-9dec-8d5ba40673a7{stroke-width:5px;}.a79ef55f-fd40-4fb4-a73f-ac32efb6b461{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "prag_automat_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f87ca073-b25d-4ae1-88b0-9429a0afe66f",
    "data-name": "sticla_2 copy 3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b74477aa-6c34-4980-963c-030318d70f5f",
    points: "91.66 137.63 91.66 185 60.91 185 60.91 5 161.66 5 161.66 185 131.66 185 131.66 137.63 91.66 137.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b74477aa-6c34-4980-963c-030318d70f5f",
    x1: 111.48,
    y1: 155.84,
    x2: 111.48,
    y2: 194
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "bff49054-fa70-4311-ab51-104a23e120cd",
    "data-name": "Arrow copy 7"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a7f81b46-c374-46eb-9dec-8d5ba40673a7",
    x1: 25.16,
    y1: 90.5,
    x2: 25.16,
    y2: 183.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "a79ef55f-fd40-4fb4-a73f-ac32efb6b461",
    d: "M16.5,149.32a2.49,2.49,0,0,1,3.45.76L40.5,182.35l20.55-32.27a2.5,2.5,0,0,1,4.22,2.69L42.61,188.34a2.5,2.5,0,0,1-4.22,0L15.73,152.77a2.54,2.54,0,0,1-.39-1.34A2.49,2.49,0,0,1,16.5,149.32Z",
    transform: "translate(-15.34 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPragAutomatWhite);
export default __webpack_public_path__ + "static/media/prag_automat_white.3aedfc01830189b38397e5d9f3634c4f.svg";
export { ForwardRef as ReactComponent };